import React, { Component } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import { AutoSizer, List as VirtualizedList } from 'react-virtualized';
import { ListFilterRow } from 'src/components/EntityPage/Filters/common';
import ReduxStore from 'src/types/store/reduxStore';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import queryString from 'qs';
import TextField from '@mui/material/TextField';
import i18n from 'src/i18n_en';

const NoIssueTypesFound = () => <div style={{ height: 175 }}>{i18n.promoTypes_noneFound}</div>;

interface ChargebacksIssueTypeForEntity {
  name: string;
  displayName: string;
  isChecked: boolean;
}

interface ChargebacksIssueTypeFilterProps {
  filters: any;
  chargeBackIssueTypes: ReduxStore['chargeBackIssueTypes'];
  entity: any;
  location: any;
  onFilterChange: (arg0: any, arg1: any) => void;
}

interface ChargebacksIssueTypeFilterState {
  searchText: string;
  issueTypesForEntity: ChargebacksIssueTypeForEntity[];
  staticSearchIssueTypes: any[];
}

class ChargebacksFilter extends Component<ChargebacksIssueTypeFilterProps, ChargebacksIssueTypeFilterState> {
  public constructor(props: ChargebacksIssueTypeFilterProps) {
    super(props);

    this.state = {
      searchText: '',
      issueTypesForEntity: [],
      staticSearchIssueTypes: []
    };
  }

  public componentWillMount() {
    this.setIssueTypes(this.props);
  }

  private setIssueTypes = (props: ChargebacksIssueTypeFilterProps) => {
    const { chargeBackIssueTypes, filters, location } = props;

    const queryParams = queryString.parse(location.search, { ignoreQueryPrefix: true, arrayLimit: 100 });
    const parsedFilterParams = queryParams.filter && queryString.parse(JSON.parse(queryParams.filter));

    const issueTypesForEntity = chargeBackIssueTypes.map((val) => {
      const isChecked =
        filters.issueType !== null &&
        parsedFilterParams &&
        parsedFilterParams.it &&
        !!parsedFilterParams.it.find((item: { i: string }) => item.i === val.name);

      return { ...val, isChecked };
    });

    this.setState({
      staticSearchIssueTypes: issueTypesForEntity,
      issueTypesForEntity,
      searchText: ''
    });
  };

  public handleCheck = (event: any, isInputChecked: boolean, index: any) => {
    const { onFilterChange } = this.props;
    const { issueTypesForEntity, staticSearchIssueTypes } = this.state;
    issueTypesForEntity[index].isChecked = isInputChecked;

    staticSearchIssueTypes.forEach((val) => {
      if (String(val.displayName) === String(issueTypesForEntity[index].displayName)) {
        val.isChecked = isInputChecked;
      }
    });
    const values = staticSearchIssueTypes.filter((val) => val.isChecked);

    this.setState({ staticSearchIssueTypes, issueTypesForEntity });
    onFilterChange(values, 'issueTypeNormalized');
  };

  private handleInputChange = ({ target: { value } }: any) => {
    const { staticSearchIssueTypes } = this.state;
    const lowerCaseVal = value.toLowerCase();
    const updatedIssueTypes = staticSearchIssueTypes.filter(({ displayName }) =>
      displayName.toLowerCase().includes(lowerCaseVal)
    );

    this.setState({ searchText: value, issueTypesForEntity: updatedIssueTypes });
  };

  public rowRenderer = ({ index, style }: any) => {
    const { issueTypesForEntity } = this.state;
    return (
      <ListFilterRow
        index={index}
        key={index}
        style={style}
        isChecked={issueTypesForEntity[index].isChecked}
        value={issueTypesForEntity[index].name}
        onCheck={this.handleCheck}
      />
    );
  };

  public render() {
    const { issueTypesForEntity, staticSearchIssueTypes, searchText } = this.state;

    if (staticSearchIssueTypes && _isEmpty(staticSearchIssueTypes)) {
      return null;
    }

    return (
      <div className="search-form-container search-form-container--sm">
        <TextField
          variant="standard"
          autoComplete="off"
          className="sl-form-input"
          placeholder="Search for Chargeback Issue Types"
          type="text"
          name="keyword"
          style={{ width: '100%' }}
          value={searchText}
          onChange={this.handleInputChange}
        />
        {issueTypesForEntity && _isEmpty(issueTypesForEntity) ? <NoIssueTypesFound /> : null}
        <AutoSizer disableHeight>
          {({ width }) => (
            <VirtualizedList
              width={width}
              height={300}
              rowCount={issueTypesForEntity.length}
              rowHeight={45}
              style={{ marginBottom: 10 }}
              rowRenderer={this.rowRenderer}
            />
          )}
        </AutoSizer>
      </div>
    );
  }
}

const mapStateToProps = (state: ReduxStore) =>
  _pick(state, ['app', 'chargeBackIssueTypes', 'comparisonTimePeriod', 'filters', 'mainTimePeriod', 'retailer']);

export default withRouter(connect(mapStateToProps)(ChargebacksFilter));
